export const APP_NAME = 'cv.katsuba.dev';
export const APP_DESCRIPTION =
  'Instant technical resume analysis for IT professionals - get AI-powered feedback in minutes';
